import { Helpers } from "./form_components";

// Explicitly define the functionality that can be connected using the ref passed 
// to FormViewer.

/**
 * Retrieves the report key or localized label for a component by field name.
 *
 * @param {string} fieldName - The name of the component field to look up.
 * @param {string} [language='en'] - The language code used for localization (default is 'en').
 * @returns {string} The component's report key if available, otherwise its localized label.
 */
export function getKeyOrLabelForField(fieldName, language = 'en') {
  let c = this.findComponents({name: fieldName})[0];
  if (!c) return null;
  if (c.reportKey) return c.reportKey;

  return Helpers.getText(c.translations, 'label', language);
}

/**
  * @param {Object} conditions - Criteria used to search for components.
  * @param {string|string[]} [conditions.dataType] - One or more data types to match components against.
  * @param {string} [conditions.id] - Component ID to search for.
  * @param {string} [conditions.name] - Component field_name to search for.
  * @param {string} [conditions.className] - Component class name to search for.
  * @returns {Object} Matched component content object
  */
export function findComponent(conditions) {
  return this.findComponents(conditions)[0];
}

export function findComponents(conditions) {
  return this.findComponents(conditions);
}

/**
 * # Currently defined events in form viewer
 * 
 * @event componentClicked
 * Dispatched on the mouseup on form component container. @see base.jsx
 * 
 * Payload: {
 *   fullFieldName: fullFieldName to the significant field for component. The components may store JSON.
 *   content: component static content,
 *   event: SyntheticEvent
 * }
 *
 */

/**
 * @param {string} event Event to listen for. See above for list of defined events
 * @param {Function} handler Must use named function for the removeEventListener to work!
 */
export function addEventListener(event, handler) {
  if (!this._eventListeners.has(event)) {
    this._eventListeners.set(event, []);
  }
  this._eventListeners.get(event).push(handler);
}

/**
 * @param {string} event Event to remove handler for. See above for list of defined events
 * @param {Function} handler Must use be a named function
 */
export function removeEventListener(event, handler) {    
  const handlers = this._eventListeners.get(event);
  // Todo, warn if if not found?  

  if (!handlers) return;

  const filtered = handlers.filter(fn => fn !== handler);
  // Todo, warn if if not found?  
  if (filtered.length > 0) {
    this._eventListeners.set(event, filtered);
  } else {
    this._eventListeners.delete(event);
  }
}

export function getAnswers() {
  const answers = this.state.answers;

  // Add 'row_count' to objects that have 'row-x' keys (Within repeatable region, showing how many rows it has) by counting how many such keys exist
  const updatedAnswers = Object.fromEntries(
      Object.entries(answers).map(([key, value]) => {
        if (typeof value === 'object' && value !== null) {
          const rowKeys = Object.keys(value).filter(k => /^row-\d+$/.test(k));
          if (rowKeys.length > 0) {
            return [key, { ...value, row_count: rowKeys.length }];
          }
        }
        return [key, value];
      })
  );

  return updatedAnswers;
}
